export const CROP_TASK_PRELOAD_COUNT = 5;

/** How many upcoming group-by labels to warm (mirrors annotate asset preload). */
export const CROP_TASK_LABEL_PRELOAD_COUNT = 5;

/**
 * Max label groups to load for a crop groupBy task.
 * Must be high enough that "N left" reflects the real remaining count
 * (previously hard-capped at 100, which always showed "100 left").
 */
export const GROUPED_LABELS_COLLECT_LIMIT = 100000;

/** Filter type 60: order for group-by label buckets. */
export const GROUP_BY_ORDER_FILTER_TYPE = 60;
export const GROUP_BY_ORDER_DEFAULT = 'random';

export function parseTaskFilters(raw) {
  if (raw == null || raw === '' || raw === false) {
    return [];
  }
  if (Array.isArray(raw)) {
    return raw;
  }
  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }
  return [];
}

export function filtersHaveGroupBy(filters) {
  return parseTaskFilters(filters).some(
    (f) => Number(f.type) === 41 && String(f.value) === 'Yes',
  );
}

export function normalizeGroupByOrder(value) {
  const v = String(value || '').toLowerCase().trim();
  if (v === 'asc' || v === 'desc' || v === 'random') {
    return v;
  }
  return GROUP_BY_ORDER_DEFAULT;
}

export function groupByOrderFromFilters(filters) {
  const found = parseTaskFilters(filters).find(
    (f) => Number(f.type) === GROUP_BY_ORDER_FILTER_TYPE,
  );
  return normalizeGroupByOrder(found ? found.value : '');
}

export function ensureGroupByOrderFilter(filters) {
  const list = parseTaskFilters(filters).slice();
  if (!list.some((f) => Number(f.type) === GROUP_BY_ORDER_FILTER_TYPE)) {
    list.push({ type: GROUP_BY_ORDER_FILTER_TYPE, value: GROUP_BY_ORDER_DEFAULT });
  }
  return list;
}

export function ensureGroupByLabelFilter(filters) {
  const list = parseTaskFilters(filters).slice();
  if (!list.some((f) => Number(f.type) === 41 && String(f.value) === 'Yes')) {
    list.push({ type: 41, value: 'Yes' });
  }
  return ensureGroupByOrderFilter(list);
}

export function filtersWithoutGroupBy(filters) {
  return parseTaskFilters(filters).filter(
    (f) => Number(f.type) !== 41 && Number(f.type) !== GROUP_BY_ORDER_FILTER_TYPE,
  );
}

export function isCropAnnotateType(annotateType) {
  return String(annotateType || '').toLowerCase() === 'crop';
}

/**
 * Build a crop grid item from a filter-boxes API item + crop API response entry.
 */
export function buildCropGridItem(item, cropEntry) {
  return {
    meta: item.meta,
    data: cropEntry.crop,
    certainty: item.certainty,
    bbox_id: item.bbox_id,
    label: item.label,
    id: item.asset_id,
    annotation_type: item.annotation_type,
    validated: item.validated || false,
    liked: item.liked || false,
    bbox_validated: item.bbox_validated === true,
    asset_validated: item.asset_validated === true,
    in_validation_set: item.in_validation_set === true,
    validation: null,
  };
}

/**
 * Preload crop images for a list of annotation filter items (best-effort).
 * Returns grid items; failed crops are skipped.
 */
export async function preloadCropItems(items, getCropFn, limit = CROP_TASK_PRELOAD_COUNT) {
  const slice = (items || []).slice(0, limit);
  const out = [];
  for (let i = 0; i < slice.length; i += 1) {
    const item = slice[i];
    try {
      const data = await getCropFn(item.url, item.bbox, item.asset_id);
      const crops = (data && data.crops) || [];
      for (let j = 0; j < crops.length; j += 1) {
        out.push(buildCropGridItem(item, crops[j]));
      }
    } catch (e) {
      // best-effort preload
    }
  }
  return out;
}
